import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { GUIDES, GUIDE_CATEGORIES, getGuidesByCategory } from '../../guides/metadata';
import GuideCard from './GuideCard';

function GuidesHome() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  // Filter guides based on category and search
  const filteredGuides = GUIDES.filter(guide => {
    const matchesCategory = !selectedCategory || guide.category === selectedCategory;
    const matchesSearch = !searchQuery ||
      guide.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      guide.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      guide.keywords.some(keyword => keyword.toLowerCase().includes(searchQuery.toLowerCase()));

    return matchesCategory && matchesSearch;
  });

  const categories = Object.values(GUIDE_CATEGORIES);

  return (
    <div className="guides-container">
      <Helmet>
        <title>Guides - Ref-Lex Reference Manager</title>
        <meta name="description" content="Learn how to use your Ref-Lex references with Microsoft Word, Overleaf, Quarto, Typst, TeXstudio, TeXmaker, and R Markdown. Step-by-step guides for academic writing." />
        <meta name="keywords" content="bibtex, reference manager, academic writing, latex, overleaf, microsoft word, quarto, typst, r markdown, bibliography, citations" />
      </Helmet>

      {/* Header */}
      <div className="guides-header">
        <a href="/" className="guides-back-link">← Back to Home</a>
        <h1 className="guides-title">Ref-Lex Guides</h1>
        <p className="guides-subtitle">
          Learn how to use your Ref-Lex references with your favorite writing tools
        </p>
      </div>

      {/* Search and Filters */}
      <div className="guides-controls">
        <div className="guides-search">
          <input
            type="text"
            placeholder="Search guides..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="guides-search-input"
          />
        </div>

        <div className="guides-categories">
          <button
            className={`category-button ${!selectedCategory ? 'active' : ''}`}
            onClick={() => setSelectedCategory(null)}
          >
            All Guides
          </button>
          {categories.map(category => (
            <button
              key={category}
              className={`category-button ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Guides Grid */}
      <div className="guides-grid">
        {filteredGuides.length > 0 ? (
          filteredGuides.map(guide => (
            <GuideCard key={guide.id} guide={guide} />
          ))
        ) : (
          <div className="guides-no-results">
            <p>No guides found matching your criteria.</p>
            <button onClick={() => { setSearchQuery(''); setSelectedCategory(null); }}>
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* Footer Section */}
      <div className="guides-footer-section">
        <h2>Need Help?</h2>
        <p>
          Can't find what you're looking for? Contact{' '}
          <a href="mailto:the-librarian@ref-lex.site">the librarian</a> for assistance.
        </p>
      </div>
    </div>
  );
}

export default GuidesHome;
